module.exports = {
	"ha": "nha",
	"id": 1.3,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 1.3</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Age Category for Northern Health <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0.927,
					1,
					0.983,
					1.009,
					1.048,
					1.057,
					1.094,
					1.097,
					1.024,
					1.035,
					0.981,
					1.051,
					1.098,
					1.076,
					1.039,
					1.132,
					1.22,
					1.1,
					1.108,
					{
						"y": 1.156,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0.619,
					0.56,
					0.581,
					0.646,
					0.615,
					0.617,
					0.6,
					0.747,
					0.649,
					0.614,
					0.627,
					0.752,
					0.708,
					0.706,
					0.7,
					0.826,
					0.811,
					0.722,
					0.706,
					{
						"y": 0.833,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.436,
					0.434,
					0.455,
					0.553,
					0.503,
					0.495,
					0.465,
					0.591,
					0.498,
					0.461,
					0.466,
					0.587,
					0.586,
					0.536,
					0.551,
					0.627,
					0.678,
					0.501,
					0.524,
					{
						"y": 0.637,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					0.844,
					0.766,
					0.866,
					1.337,
					0.936,
					0.925,
					0.903,
					1.096,
					1.085,
					0.868,
					0.889,
					1.235,
					1.171,
					1.041,
					0.992,
					1.198,
					1.284,
					1.124,
					1.175,
					{
						"y": 1.285,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_1_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_1_3.json
// module id = 251
// module chunks = 0